import { Injectable } from '@angular/core';
import { FabricService } from '../fabric/fabric.service';
import { Observable } from 'rxjs';
import { WorkflowApproval } from '../../models/workflow-approval/workflow-approval';
import { WorkflowApprovalSearchRequest } from '../../models/workflow-approval/workflow-approval-search-request';

const SERVICE_NAME = 'workflow-resources';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  constructor(private fabricService: FabricService) { }

  postWorkflowApproval(workflowEntry: WorkflowApproval): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_workflow-approval', workflowEntry);
  }

  search(searchRequest: WorkflowApprovalSearchRequest): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_workflow-approval_search', searchRequest);
  }

  deleteWorkflowApproval(workflowId: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_workflow-approval_workflow_workflowid',
      { workflowId });
  }
}
